export type DeviceType = 'mobile' | 'tablet' | 'desktop';

export interface NavigatorService {
  getUserAgent(): string;
  getDeviceType(): DeviceType;
}

export class BrowserNavigatorService implements NavigatorService {
  getUserAgent(): string {
    return navigator.userAgent;
  }

  getDeviceType(): DeviceType {
    // Heuristic only; can be replaced per-platform later if needed.
    const ua = navigator.userAgent.toLowerCase();

    if (ua.includes('ipad') || ua.includes('tablet')) {
      return 'tablet';
    }
    if (ua.includes('mobi') || ua.includes('iphone') || ua.includes('android')) {
      return 'mobile';
    }

    return 'desktop';
  }
}
